import z from 'zod';

export const MetricSchema = z.object({
  name: z.string(),
  isExportable: z.boolean()
});

export const MetricGroupSchema = z.object({
  id: z.string(),
  name: z.string(),
  metrics: z.array(MetricSchema)
});

export const MetricGroupListSchema = z.array(MetricGroupSchema);

export type Metric = z.infer<typeof MetricSchema>;
export type MetricGroup = z.infer<typeof MetricGroupSchema>;
